const re = /([0-9]+|([A-Z][a-z]+)|[a-z]+|([A-Z]+)(?![a-z]))/g;

export const kebabCase = str =>
  (String(str ?? '').match(re) || []).map(x => x.toLowerCase()).join('-');
